import { useState } from "react";
import {
  isDistinctMarker,
  pointerPctWithinTrack,
  sliderFillPct,
} from "./slider-math";

const GHOST_VARIANTS = [
  { height: "70%", top: "15%" },
  { height: "60%", top: "20%" },
];

export default function ControlSlider({
  label,
  min,
  max,
  step,
  value,
  markerPcts,
  disabled = false,
  onChange,
  ghostEnabled = false,
}) {
  const [ghost, setGhost] = useState({
    active: false,
    pct: 0,
    ...GHOST_VARIANTS[0],
  });

  const fillPct = sliderFillPct({ min, max, value });
  const markerPoints = markerPcts.filter((pct) =>
    isDistinctMarker(pct, fillPct),
  );

  const setGhostAt = (event, active) => {
    if (!ghostEnabled || disabled) return;

    const variant = GHOST_VARIANTS[Math.floor(Math.random() * GHOST_VARIANTS.length)];
    setGhost({
      active,
      pct: pointerPctWithinTrack(event.clientX, event.currentTarget),
      ...variant,
    });
  };

  return (
    <div className="slider">
      <div className="slider__label">{label}</div>
      <div
        className="slider__track"
        onMouseEnter={ghostEnabled ? (event) => setGhostAt(event, true) : undefined}
        onMouseMove={
          ghostEnabled
            ? (event) => setGhostAt(event, ghost.active)
            : undefined
        }
        onMouseLeave={
          ghostEnabled ? () => setGhost((current) => ({ ...current, active: false })) : undefined
        }
        onMouseDown={
          ghostEnabled ? () => setGhost((current) => ({ ...current, active: false })) : undefined
        }
        onMouseUp={ghostEnabled ? (event) => setGhostAt(event, true) : undefined}
      >
        <div className="slider__points slider__points--markers" aria-hidden="true">
          {markerPoints.map((pointPct) => (
            <div
              key={pointPct}
              className="slider__point"
              style={{ "--point-pct": pointPct }}
            />
          ))}
        </div>

        <div className="slider__points slider__points--active" aria-hidden="true">
          <div
            className="slider__point slider__point--active"
            style={{ "--point-pct": fillPct }}
          />
        </div>

        {ghostEnabled && (
          <div
            className={`slider__ghost ${ghost.active ? "slider__ghost--active" : ""}`}
            style={{
              "--point-pct": ghost.pct,
              height: ghost.height,
              top: ghost.top,
            }}
          />
        )}

        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
    </div>
  );
}
